<template>
    <div>
       <HeaderTeam header="รายงานและการสรุปยอด" :img_header="header_image" link_back="summary"/>
       <MenuTeamReportAndSummaryList/>
       <DetailEmployeeSummaryList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/dashboard.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamReportAndSummaryList from '@/components/menuadmin/team/teamreportandsummary/MenuTeamReportAndSummaryList.vue'
import DetailEmployeeSummaryList from '@/components/menuadmin/team/teamreportandsummary/DetailEmployeeSummaryList.vue'
export default {
    name:'detailEmployeeSummary',
    components:{
        HeaderTeam,
        MenuTeamReportAndSummaryList,
        DetailEmployeeSummaryList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>